exports.songsdata = [
    {
        "title": "Jubilife City(day)",
        "url": "https://vgmsite.com/soundtracks/pok-mon-diamond-pok-mon-pearl-super-music-collection-2006/iilhdibsjp/1-23%20-%20Jubilife%20City%20%28Day%29.mp3"
    },
    {
        "title": "Canalave City",
        "url": "https://vgmsite.com/soundtracks/pok-mon-diamond-pok-mon-pearl-super-music-collection-2006/kirgzfptjn/1-62%20-%20Canalave%20City.mp3"
    },
    {
        "title": "Twinleaf Town(Day)",
        "url": "https://vgmsite.com/soundtracks/pok-mon-diamond-pok-mon-pearl-super-music-collection-2006/zhamzuwbbc/1-05%20-%20Twinleaf%20Town%20%28Day%29.mp3"
    }
]